export const formatterDate = new Intl.DateTimeFormat("en-au", {
  year: "2-digit",
  month: "2-digit",
  day: "2-digit",
});

export const formatterDay = new Intl.DateTimeFormat("en-au", {
  weekday: "short",
});

export const formatterTime = new Intl.DateTimeFormat("en-au", {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
});

export const formatterTime24 = new Intl.DateTimeFormat("en-au", {
  hourCycle: "h23",
  hour: "2-digit",
  minute: "2-digit",
});

export const getSeverityColour = (
  displaySettings,
  value,
  defaultColour = "transparent"
) => {
  const severitySetting = getSeveritySetting(displaySettings, value);
  return (severitySetting && severitySetting.colour) || defaultColour;
};

const getSeveritySetting = (displaySettings, value) =>
  displaySettings && displaySettings.find((d) => d.value === value);

export async function loadFileAsText(fileUnion) {
  return new Promise((resolve, reject) => {
    fileUnion.case({
      FileSystem: (file) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;

        reader.readAsText(file);
      },
      Url: async (url) => {
        try {
          const response = await fetch(url);
          const data = await response.text();
          resolve(data);
        } catch (e) {
          reject(e);
        }
      },
    });
  });
}

export const downloadFile = (data, name) => {
  //download file
  const element = document.createElement("a");
  element.href = data;
  element.download = name;
  document.body.appendChild(element); // Required for this to work in FireFox
  element.click();
  URL.revokeObjectURL(element);
  document.body.removeChild(element);
};
